import React, { FC, useState, useEffect } from 'react'
import { ID } from '@/_metronic/helpers'
import { RepartitionData } from '../core/_models'
import { getRepartition } from '../core/_requests'
import { DonutCard } from '@/components/cards/DonutCard'

type Props = {
  userId?: ID
  from: Date
  to: Date
  timezone: string;
  height: number
}
const EarningsRepartitionChart: FC<Props> = ({ userId, from, to, height, timezone }) => {
  const [data, setData] = useState<Array<RepartitionData> | undefined>()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    const load = async () => {
      try {
        setIsLoading(true)
        const res = await getRepartition({ from, to, userId, timezone })
        setData(res || [])
      } catch (e: unknown) {
        console.log(e)
      } finally {
        setIsLoading(false)
      }
    }
    load()
  }, [userId, from, to])

  return (
    <DonutCard
      id="user-repartition"
      title="Earnings"
      height={height}
      isLoading={isLoading}
      isMoney={true}
      showTotal={true}
      data={(data || []).map(d => ({
        label: d.source,
        value: d.value
      }))}
    />
  )
}

export default EarningsRepartitionChart
